import React from 'react';

function signed(value, digits = 2, suffix = '') {
  const number = Number(value);
  if (!Number.isFinite(number)) return '—';
  return `${number > 0 ? '+' : ''}${number.toFixed(digits)}${suffix}`;
}

function plain(value, digits = 1, suffix = '') {
  const number = Number(value);
  return Number.isFinite(number) ? `${number.toFixed(digits)}${suffix}` : '—';
}

export default function NavAnomalyPanel({ review }) {
  if (!review) return null;
  if (!review.available) return <p className="decision-muted">{review.reason || '净值异常识别样本不足。'}</p>;
  return (
    <div className={`nav-anomaly-panel anomaly-${review.status?.key || 'clear'}`}>
      <div className="nav-anomaly-head">
        <div><span>净值异常复核</span><strong>{review.status?.label}</strong></div>
        <p>{review.status?.note}</p>
      </div>
      <div className="nav-anomaly-kpis">
        <div><span>大幅变动日</span><strong>{review.count}</strong><small>{review.sample_size}个样本，占{plain(review.ratio_pct, 1, '%')}</small></div>
        <div><span>识别阈值</span><strong>{plain(review.threshold_pct, 4, '%')}</strong><small>相对产品自身常态的偏离</small></div>
        <div><span>前3日波动占比</span><strong>{plain(review.top3_absolute_share_pct, 1, '%')}</strong><small>占全部绝对日变动</small></div>
        <div><span>大幅变动净贡献</span><strong>{signed(review.anomaly_net_contribution_bp, 1, 'bp')}</strong><small>只用于判断结果是否受少数日期影响</small></div>
      </div>
      {review.items?.length ? (
        <details className="nav-anomaly-details">
          <summary>查看主要大幅净值变动日（前{review.items.length}个）</summary>
          <div className="nav-anomaly-table-wrap">
            <table>
              <thead><tr><th>日期</th><th>日变动</th><th>单位净值</th><th>万份收益</th><th>随后3点净变动</th><th>形态</th></tr></thead>
              <tbody>{review.items.map((item) => (
                <tr key={item.date}>
                  <td>{item.date}</td>
                  <td className={item.direction === 'up' ? 'tone-positive' : 'tone-negative'}>{signed(item.change_pct, 4, '%')}</td>
                  <td>{plain(item.unit_nav, 6)}</td>
                  <td>{signed(item.daily_income, 2)}</td>
                  <td>{signed(item.following_3point_net_pct, 4, '%')}</td>
                  <td>{item.pattern}</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        </details>
      ) : null}
      <p className="nav-anomaly-method">{review.method}</p>
    </div>
  );
}
